<template>
  <div :class="isMobile ? 'header-m' : 'header'">
    <div class="topNav">
      <el-row type="flex" justify="space-between">
        <el-col :span="isMobile ? 8 : 4" class="logo">
            <img src="./../assets/logo-blue.png" />
        </el-col>
        <el-col :span="12" class="menu">
            <span class="menuItem" v-for="(item) in menuList" :key="item.name">
              <router-link 
                :to="item.url" 
                :class="item.includeName?.includes(currentName) ? 'currentItem': ''"
              >{{item.name}}</router-link>
            </span>
        </el-col>
        <el-col :span="8" class="connect" v-show="!isMobile">
          <div>
            <div class="connect-one">
              <img src="../assets/homeIcon/phone.png" class="connect-one-img" />
              <span class="connect-one-text">15255615034</span>
            </div>
            <div class="connect-one">
              <img src="../assets/icon/taobao-empty.png" class="connect-one-img" />
              <span class="connect-one-text">
                <a href="https://shop503054747.taobao.com/?spm=pc_detail.30350276.shop_block.dshopinfo.4ccb1479InwI6i" target="_blank">
                  淘宝商城
                </a>
              </span>
            </div>
            <div class="connect-one">
              <img src="../assets/homeIcon/wechat.png" class="connect-one-img" />
              <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="tpopover">
                <div>
                  <img :src="imgUrl.codePer" />
                </div>
                <span class="connect-one-text" slot="reference">官方微信</span>
              </el-popover>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="mobile-menu">
            <el-button icon="el-icon-s-unfold" @click="drawer = true"></el-button>
        </el-col>

      </el-row>
    </div>
    <div>
      <el-drawer
        title=""
        :visible.sync="drawer"
        size="50%"
        :modal="false"
        direction="rtl">
        <div class="mobile-menu-item">
          <span class="menuItem" v-for="(item) in menuList" :key="item.name" @click="clickmenu">
            <router-link 
              :to="item.url" 
              :class="item.includeName?.includes(currentName) ? 'currentItem': ''"
            >{{item.name}}</router-link>
          </span>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import imgUrl from "@/utils/imgUrl"
export default {
  name: 'Header',
  data() {
    return {
      imgUrl,
      isMobile: window.innerWidth < 780,
      drawer: false,
      currentName: this.$route.name,
      menuList: [
        {
          name: '首页',
          url: '/home',
          includeName: ['home']
        }, {
          name: '产品中心',
          url: '/product',
          includeName: ['productDetail', 'product']
        }, {
          name: '解决方案',
          url: '/plan',
          includeName: ['plan', 'planDetail']
        }, {
          name: '应用领域',
          url: '/place',
          includeName: ['place']
        // }, {
        //   name: '技术创新',
        //   url: '/gain',
        //   includeName: ['gain']
        }, {
          name: '走进艾感',
          url: '/about',
          includeName: ['about']
        }, {
          name: '新闻动态',
          url: '/news',
          includeName: ['news']
        }, {
          name: '加入我们',
          url: '/join',
          includeName: ['join']
        }
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.initFunc)
  },
  methods: {
    clickmenu() {
      this.drawer = false // 选择了菜单之后关闭抽屉
    },  
    initFunc() {
      this.isMobile = window.innerWidth < 780
    },
    jumptoprod(url) {
      // window.sessionStorage.setItem("scroll", 100)
      this.$router.push(url);
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
  },
  watch: {
    "$route.path" (to, from){
      // console.log("this.$route.name", this.$route.name)
      this.currentName = this.$route.name
    }
  },
  props: {
    msg: String
  }
}
</script>


<style lang="less">
  .tpopover{
    min-width: 100px !important;
    text-align: center !important;
    border-radius: 8px !important;
    position: relative;
  }
  .header{
    position: relative;
    .topNav{
     max-width: 1400px;
     margin: 0 auto;
    }
    .logo {
      padding: 30px 2% 10px 4%;
      vertical-align: middle;
      img {
        width: 100%;
        display: block;
      }
    }
    .menu{
      vertical-align: middle;
      .menuItem{
        padding: 34px 1.8%;
        font-size: 15px;
        font-weight: bold;
        display: inline-block;
        a{
          color: #3E363080;
          text-decoration: none;
        }
        a:hover{
          color: #00D0FF;
        }
        .router-link-active{
          color: #00D0FF;
        }
        .currentItem{
          color: #00D0FF;
        }
      }
    }
    .connect{
      line-height: 90px;
      .connect-one{
        display: inline-block;
        margin-right: 28px;
        .connect-one-img{
          width: 18px;
          height: 18px;
          display: inline-block;
          margin-right: 4px;
          vertical-align: middle;
        }
      }
    }
    .word{
      text-align: center;
      color: #fff;
      margin: 66px 0;
      .btn{
        background: rgb(39, 46, 55);
        border: none;
        color: #ffffffc9;
        margin: 20px;
      }
    }
  }
  .mobile-menu{
    display: none;
  }

  // 移动端
  .header-m{
    text-align: left;
    .logo{
      margin: 0.2rem 0.2rem 0 0.5rem;
      img {
        width: 100%;
      }
    }
    .bannerbox{
      overflow: hidden;
    }
    .menu{
      display: none;
    }
    .mobile-menu{
      display: block;
      position: absolute;
      right: 0.3rem;
      top: 0rem;
      text-align: right;
      .el-button{
        background: none;
        border-color: #00D0FF;
        color: #00D0FF;
        font-size: 0.6rem;
        padding: 0.1rem 0.16rem;
      }
      a{
        color: #ffffffac;
        text-decoration: none;
      }
    }
    .mobile-menu-item{
      .menuItem{
        display: block;
        text-align: left;
        margin-left: 0.4rem;
        margin-right: 0.2rem;
        a{
          text-decoration: none;
          color: #989898;
          font-size: 0.4rem;
          line-height: 1.2rem;
          border-left: 0.14rem solid #dedede;
          border-bottom: 0.01rem solid #dedede;
          display: block;
          padding: 0 1rem;
        }
        .router-link-active{
          color: #00D0FF;
          border-left: 0.08rem solid #00D0FF;
        }
        .currentItem{
          color: #00D0FF;
          border-left: 0.08rem solid #00D0FF;
        }
      }
    }
  }
  /deep/ .el-drawer{
    background: #00D0FF;
  }
  /deep/ .el-drawer__close-btn{
    font-size: 0.6rem;
    color: #989898;
  }
  /deep/ .el-drawer__header{
    padding: 0.4rem 0 0;
  }
</style>
